module.exports = __webpack_public_path__ + "static/19-2afced7cc5e1b050e5d143e6f11bd558.jpg";